module.exports = __webpack_public_path__ + "img/10.1d48199d.png";